var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.486816,
    width: 30.7895,
    height: 30.7895,
    rx: 15.3948,
    fill: "#43B4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.862 7.86166L23.4427 9.2218C23.3185 9.31642 23.2593 9.47018 23.283 9.61802V19.6299C23.2593 19.7836 23.3185 19.9374 23.4427 20.0261L24.8324 21.3863V21.6878H17.8542V21.3981L19.2913 20.0024C19.4332 19.8605 19.4332 19.8191 19.4332 19.6062V11.5104L15.4355 21.6583H14.8974L10.2433 11.5104V18.3111C10.2019 18.595 10.3025 18.8848 10.5035 19.0917L12.3723 21.3567V21.6583H7.06177V21.3567L8.93049 19.0917C9.13156 18.8848 9.22026 18.595 9.17295 18.3111V10.4459C9.19661 10.2271 9.11382 10.0142 8.94823 9.8664L7.28649 7.86166V7.56006H12.4491L16.435 16.3123L19.9418 7.56597H24.862V7.86166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogo);
export default __webpack_public_path__ + "static/media/m-logo.b565f40c61a4cf408397dbfd82facacc.svg";
export { ForwardRef as ReactComponent };